module.exports = __webpack_public_path__ + "static/media/download.37099ee3.png";